import React from "react";
import PropTypes from "prop-types";
import "./FilterBar.scss";

// Helper small component for CSS-driven radio dropdown
function RadioDropdown({
  name,
  value,
  onChange,
  defaultLabel,
  options,
  className,
}) {
  return (
    <div className={`filterbar-select ${className ?? ""}`}>
      <div
        className="filterbar-selected"
        role="button"
        tabIndex={0}
        aria-expanded="false"
      >
        <span className="filterbar-selected-text">
          {options.find((o) => o.value === value)?.label ?? defaultLabel}
        </span>
        <svg
          className="filterbar-arrow"
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 512 512"
        >
          <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
        </svg>
      </div>

      <div className="filterbar-options" role="menu" aria-hidden="true">
        {options.map((opt) => {
          const id = `${name}-${opt.value}`;
          return (
            <div
              key={opt.value}
              title={opt.value}
              className="filterbar-option-row"
            >
              <input
                id={id}
                name={name}
                type="radio"
                checked={value === opt.value}
                onChange={() => {
                  onChange(opt.value);

                  // 🔥 This part forces the dropdown to close immediately after select
                  const parent = document
                    .getElementById(id)
                    ?.closest(".filterbar-select");
                  if (parent) {
                    parent.classList.add("filterbar-force-close");
                    setTimeout(() => {
                      parent.classList.remove("filterbar-force-close");
                    }, 80); // <- close delay (80ms)
                  }
                }}
              />

              <label
                className="filterbar-option"
                htmlFor={id}
                data-txt={opt.label}
              >
                {opt.label}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}

RadioDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultLabel: PropTypes.string,
  options: PropTypes.array.isRequired,
  className: PropTypes.string,
};

export default function FilterBar({ filters, onChange }) {
  const handle = (patch) => onChange({ ...filters, ...patch });

  const sortOptions = [
    { value: "newest", label: "Newest first" },
    { value: "oldest", label: "Oldest first" },
  ];

  return (
    <div className="filterbar-root">
      <div className="filterbar-left">
        <RadioDropdown
          name="sortFilter"
          value={filters.sort}
          onChange={(v) => handle({ sort: v })}
          defaultLabel="Newest first"
          options={sortOptions}
          className="filterbar-select--sort"
        />
      </div>

      <div className="filterbar-right">
        <input
          className="filterbar-input"
          type="search"
          placeholder="Search title or remark..."
          value={filters.q}
          onChange={(e) => handle({ q: e.target.value })}
          aria-label="Search tasks"
        />
      </div>
    </div>
  );
}

FilterBar.propTypes = {
  filters: PropTypes.shape({
    q: PropTypes.string,
    status: PropTypes.string,
    sort: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
